import { put } from "@/api";
import type { IUserLayout } from "@/api/interfaces/userLayouts";
import { ApiPath } from "@/api/paths";
import type { ApiRequest, BodyWrapper, RequestResponse } from "@/api/types";

const personData: ApiRequest<
  RequestResponse<IUserLayout>,
  BodyWrapper<void>
> = async ({ ...options }) =>
  put({
    ...options,
    api: ApiPath.User.person,
    canFail: true,
  });

const UserAuth = {
  personData,
};

export default UserAuth;
